import { IModifySavingsAgreementFund } from "../../../../../types/api/IModifySavingsAgreementFund";
import { ISavingPropositionFund } from "../../../../../types/robot/ISavingPropositionFund";

/**
 * Function to map funds from the savings proposal to the funds for the request for a savings agreement.
 * The funds from the proposal is of the type ISavingPropositionFundDto.
 * @param data
 * @returns a list of the type IModifySavingsAgreementFundDto
 */
export const MapFundsToSavingsAgreement = (data: ISavingPropositionFund[] | undefined) => {
  if (data === undefined) return [];

  const agreementFunds = [] as IModifySavingsAgreementFund[];

  data.forEach((_, i) => {
    agreementFunds.push({
      isin: data[i].isin,
      amount: data[i].monthlySaving,
      name: data[i].name,
      percentage: data[i].percentageOfTotal,
    } as IModifySavingsAgreementFund);
  });

  return agreementFunds;
};
